(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .factory('DragCheckerSvc', DragCheckerSvc);

    function DragCheckerSvc() {
        var eventItemEnter = 'mouseenter';
        var eventItemLeave = 'mouseleave';
        var eventTouchMove = 'touchend';
        var isOverDestCounterString = 'isOverDestCounter';

        function getInstance(destElementSelector, sourceElementSelector) {
            return {
                bindEvents: function() {
                    var destElements = angular.element(destElementSelector);
                    var sourceElement = angular.element(sourceElementSelector);

                    destElements.bind(eventItemLeave, function() {
                        var isOverDestCounter = destElements.data(isOverDestCounterString) || 1;
                        isOverDestCounter--;
                        destElements.data(isOverDestCounterString, isOverDestCounter);
                    });
                    destElements.bind(eventItemEnter, function() {
                        var isOverDestCounter = destElements.data(isOverDestCounterString) || 0;
                        isOverDestCounter++;
                        destElements.data(isOverDestCounterString, isOverDestCounter);
                    });

                    sourceElement.bind(eventTouchMove, function(event) {
                        var endTouchElement = document.elementFromPoint(event.originalEvent.changedTouches[0].clientX, event.originalEvent.changedTouches[0].clientY);

                        for (var i = 0; i < destElements.length; i++) {
                            if (destElements[i].contains(endTouchElement)) {
                                destElements.data(isOverDestCounterString, 1);
                            }
                        }
                    });
                },
                unbindEvents: function() {
                    var destElements = angular.element(destElementSelector);
                    var sourceElement = angular.element(sourceElementSelector);

                    destElements.unbind(eventItemLeave);
                    destElements.unbind(eventItemEnter);
                    sourceElement.unbind(eventTouchMove);
                },
                isOverDest: function() {
                    var destElements = angular.element(destElementSelector);

                    var isOverDest = destElements.data(isOverDestCounterString) >= 1;
                    destElements.data(isOverDestCounterString, 0);
                    return isOverDest;
                }
            };
        }

        return {
            getInstance: getInstance
        };
    }
})();